import { render } from "./field-color.vue?vue&type=template&id=09837690"
import script from "./field-color.vue?vue&type=script&lang=js"
export * from "./field-color.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__